import React from 'react'

function TenderTextNonReturn() {
  return (
    <embed src="\pdfs\EA2.4_rk-e20_08.2013-kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextNonReturn